module.exports = __webpack_public_path__ + "static/media/zls.44ae84c1.jpg";